//Services.js
import React from 'react'
import { Text, View } from 'react-native'
import styles from './Styles.js'

//const border = 1;

const Services = () => {
  return (
    <View>
      <Text style={styles.titleText}>Services</Text>
      <Text style={styles.baseText}>Tutoring</Text>
      <Text></Text>
      <Text style={styles.baseText}>Private classes</Text>
      <Text></Text>
      <Text style={styles.baseText}>School monitoring</Text>
      <Text></Text>
      <Text style={styles.baseText}>Career counseling</Text>
      <Text></Text>
      <Text style={styles.baseText}>Exam preparation</Text>
      <Text> </Text>
      <Text> </Text>
    </View>
  )
};
export default Services;
